import cx from "classnames";
import React, { Fragment } from "react";

import styles from "./styles.module.css";

export const MultiSwitch = ({
  theme = "light",
  className = "",
  onChange,
  activeId,
  elems,
}) => {
  return (
    <div className={cx(styles.buttonContainer, styles[theme], className)}>
      {elems.map(({ id, label }, i) => (
        <Fragment key={id}>
          {i !== 0 && (
            <span className={styles.buttonDivider}>&nbsp;|&nbsp;</span>
          )}
          <button
            key={id}
            className={cx(styles.button, {
              [styles._isActive]: activeId === id,
            })}
            onClick={() => onChange(id)}
          >
            <span>{label}</span>
          </button>
        </Fragment>
      ))}
    </div>
  );
};
